import { render, staticRenderFns } from "./LPTemp5.vue?vue&type=template&id=3cc300c8&scoped=true&"
import script from "./LPTemp5.vue?vue&type=script&lang=js&"
export * from "./LPTemp5.vue?vue&type=script&lang=js&"
import style0 from "./LPTemp5.vue?vue&type=style&index=0&id=3cc300c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc300c8",
  null
  
)

export default component.exports